module.exports = __webpack_public_path__ + "static/media/register.19aceb8b.svg";